import { QueryClient, useMutation } from "@tanstack/react-query";
import { closeMapperNote } from "../../../apis";
import { Storage } from "common/storage";

export function useCloseMapperNote() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = new QueryClient();

  const { mutate, error, status, data } = useMutation({
    mutationFn: ({ issueId }: { issueId: string }) => {
      return closeMapperNote(issueId, accessToken || "");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["loadVenueDetailsBySlug"],
        exact: false,
      });
    },
  });

  return { closeNote: mutate, error, isLoading: status === "pending", data };
}
